import { adapter } from '@seek/tealium-adapter';

import { createCypressTracker } from 'src/app/utils/cypress';

import type {
  ViewEventData,
  ViewEventName,
} from '../getViewEventDataByPage/type';

const { initCypressTracker, sendUtagViewEventToCypressTracker } =
  createCypressTracker();

initCypressTracker();

const sendUtagViewEvent = (eventName: ViewEventName, data: ViewEventData) => {
  const tracker = adapter();
  tracker.view(eventName, data);
  sendUtagViewEventToCypressTracker(eventName, data);
};

export default sendUtagViewEvent;
